import Preact, { Component, h } from 'preact'

interface Props {
  name: string
  ariaLabel: string
  id: string
  label?: string
  subtext?: string
  isControl?: boolean
  isInline?: boolean
  enableFocusToInput?: boolean
  updateInputValue?: string
  placeholder?: string
  defaultValue?: string
  direction?: 'vertical' | 'horizontal'
  size?: 'S' | 'M' | 'L' | 'fullWidth'
  onChange?: (value: string) => void
  onKeyUp?: (value: string) => void
}

interface State {
  inputValue: string
}

class TextField extends Component<Props, State> {
  input?: HTMLInputElement

  constructor (props: Props) {
    super(props)

    this.state = {
      inputValue: props.defaultValue ?? ''
    }

    this.handleOnChange = this.handleOnChange.bind(this)
    this.handleOnKeyUp = this.handleOnKeyUp.bind(this)
  }

  handleOnChange (value: string) {
    this.setState({
      inputValue: value
    })

    if (this.props.onChange && typeof this.props.onChange === 'function') {
      this.props.onChange(value)
    }
  }

  handleOnKeyUp (value: string) {
    this.setState({
      inputValue: value
    })
    if (this.props.onKeyUp && typeof this.props.onKeyUp === 'function') {
      this.props.onKeyUp(value)
    }
  }

  componentDidUpdate (previousProps: Readonly<Props>) {
    if (previousProps.enableFocusToInput !== this.props.enableFocusToInput && this.props.enableFocusToInput && this.input) {
      this.input.focus()
      setTimeout(() => {
        if (this.input) {
          this.input.focus()
        }
      }, 100)
    }
    if (previousProps.updateInputValue !== this.props.updateInputValue && typeof this.props.updateInputValue === 'string' && this.input) {
      this.input.value = this.props.updateInputValue
      this.setState({ inputValue: this.props.updateInputValue })
      this.handleOnChange(this.props.updateInputValue)
      this.handleOnKeyUp(this.props.updateInputValue)
    }
  }

  render ({ name, ariaLabel, id, label, isControl, size = 'fullWidth', subtext, direction = 'vertical', placeholder = '', isInline = false }: Props,
    { inputValue }: State) {
    return (
      <div className={`a-text-field a-text-field--app-${isControl ? 'control' : 'destination'}
      a-text-field--size-${size} a-text-field--direction-${direction} ${isInline ? 'a-text-field--type-inline' : ''}`}
      >
        {label ? <label className='a-text-field--label' for={id}>{label}</label> : null}
        {subtext ? <p className='a-text-field--subtext'>{subtext}</p> : null}
        <input
          ref={(input: HTMLInputElement) => { this.input = input }}
          placeholder={placeholder}
          className='a-text-field--input'
          id={id} name={name}
          aria-label={ariaLabel} value={inputValue}
          onChange={(e: Preact.FormEvent<HTMLInputElement>) => this.handleOnChange(e.target.value)}
          onKeyUp={(e: Preact.FormEvent<HTMLInputElement>) => this.handleOnKeyUp(e.target.value)}
        />
      </div>
    )
  }
}

export default TextField
